import { QueryObserver, parseQueryArgs } from '@tanstack/query-core';
import { createBaseQuery } from './createBaseQuery';
export function createQuery(arg1, arg2, arg3) {
    const parsedOptions = parseQueryArgs(arg1, arg2, arg3);
    const result = createBaseQuery(parsedOptions, QueryObserver);
    return result;
}
